export default __webpack_public_path__ + "static/media/card8.c2470690.jpg";